/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RealEstateEligibilityDto
 */
export interface RealEstateEligibilityDto {
    /**
     * 
     * @type {string}
     * @memberof RealEstateEligibilityDto
     */
    realEstateId?: string;
    /**
     * 
     * @type {string}
     * @memberof RealEstateEligibilityDto
     */
    status?: RealEstateEligibilityDtoStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof RealEstateEligibilityDto
     */
    reasons?: Array<string>;
}


/**
 * @export
 */
export const RealEstateEligibilityDtoStatusEnum = {
    Eligible: 'Eligible',
    ACompleter: 'ACompleter',
    NonEligible: 'NonEligible'
} as const;
export type RealEstateEligibilityDtoStatusEnum = typeof RealEstateEligibilityDtoStatusEnum[keyof typeof RealEstateEligibilityDtoStatusEnum];


/**
 * Check if a given object implements the RealEstateEligibilityDto interface.
 */
export function instanceOfRealEstateEligibilityDto(value: object): value is RealEstateEligibilityDto {
    return true;
}

export function RealEstateEligibilityDtoFromJSON(json: any): RealEstateEligibilityDto {
    return RealEstateEligibilityDtoFromJSONTyped(json, false);
}

export function RealEstateEligibilityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RealEstateEligibilityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'realEstateId': json['realEstateId'] == null ? undefined : json['realEstateId'],
        'status': json['status'] == null ? undefined : json['status'],
        'reasons': json['reasons'] == null ? undefined : json['reasons'],
    };
}

export function RealEstateEligibilityDtoToJSON(json: any): RealEstateEligibilityDto {
    return RealEstateEligibilityDtoToJSONTyped(json, false);
}

export function RealEstateEligibilityDtoToJSONTyped(value?: RealEstateEligibilityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'realEstateId': value['realEstateId'],
        'status': value['status'],
        'reasons': value['reasons'],
    };
}

